import { useCherreValue } from '@cherre-frontend/data-fetching';
import { useLazyLoadQuery } from 'react-relay';
import {
  ConnectorEnvironments,
  useConnectorEnvironment,
} from 'src/hooks/useConnectorEnvironment';
import {
  connectorLandingActivityOverviewDemo,
  connectorLandingScheduleDemo,
  connectorLandingSourcesDemo,
  connectorLandingStatusesDemo,
} from 'src/services/ConnectorDemo/recoil';
import {
  connectorLandingActivityOverview,
  connectorLandingSchedule,
  connectorLandingSources,
  connectorLandingStatuses,
} from 'src/services/DOM/connectorLanding/recoil';
import { RulesQuery } from '../../connector-details/components/DataValidationV2/queries/types';
import { DataValidationRulesLibraryQuery } from '../../connector-details/components/DataValidationV2/queries/dataValidationRulesLibraryQuery';
import { Activity } from 'src/services/ConnectorDemo/data/ConnectorLanding';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';

const useCountV2 = (data: Activity[]) => {
  //this is really bad pattern, but it is the only way to get the dataValidationRulesLibrary
  //query to work in the connector landing page
  //DELPHI intends to refactor this in the near future
  //TODO: remove this when we refactor the connector landing page
  return data.reduce((acc, activity) => {
    try {
      const result = useLazyLoadQuery<RulesQuery>(
        DataValidationRulesLibraryQuery,
        {
          connectorComponentRef: {
            name: activity.modelName,
            version: activity.modelRevision,
            kind: 'Model',
          },
        }
      );
      const rules = result.validationRulesLibrary?.filter(
        (rule) => rule.status !== 'INACTIVE'
      );
      return (
        acc + (rules?.filter((rule) => rule.status === 'FAIL').length ?? 0)
      );
    } catch (e) {
      if (e instanceof Promise) {
        throw e;
      }
      return acc + (activity.numFailedValidationChecks ?? 0);
    }
  }, 0);
};

export const useConnectorLanding = () => {
  const environment = useConnectorEnvironment();

  if (environment === ConnectorEnvironments.MVP) {
    const connectorActivityOverview = useCherreValue(
      connectorLandingActivityOverview
    );
    const connectorStatuses = useCherreValue(connectorLandingStatuses);
    const isValidationV2 = useFeatureFlag('ConnectorsDataValidationV2');
    const connectorSources = useCherreValue(connectorLandingSources);
    const connectorSchedule = useCherreValue(connectorLandingSchedule);
    if (isValidationV2) {
      const failedChecks = useCountV2(connectorActivityOverview?.data || []);
      return {
        connectorStatuses: connectorStatuses
          ? { data: { ...connectorStatuses.data, failedChecks } }
          : null,
        connectorActivityOverview,
        connectorSources,
        connectorSchedule,
      };
    }
    return {
      connectorStatuses,
      connectorActivityOverview,
      connectorSources,
      connectorSchedule,
    };
  }

  const connectorStatuses = useCherreValue(connectorLandingStatusesDemo);
  const connectorActivityOverview = useCherreValue(
    connectorLandingActivityOverviewDemo
  );
  const connectorSources = useCherreValue(connectorLandingSourcesDemo);
  const connectorSchedule = useCherreValue(connectorLandingScheduleDemo);
  return {
    connectorStatuses,
    connectorActivityOverview,
    connectorSources,
    connectorSchedule,
  };
};
